import { Action, createReducer, on } from '@ngrx/store';
import {
  CERTIFICA_EMAIL,
  CERTIFICA_EMAIL_SUCCESS,
  CERTIFICA_EMAIL_FAIL,
  CERTIFICA_EMAIL_RESET,
  CERTIFICA_OTP,
  CERTIFICA_OTP_SUCCESS,
  CERTIFICA_OTP_FAIL,
  CERTIFICA_EMAIL_PRELOAD,
} from './certifica-email.actions';
import { ICertificaEmailState } from './certifica-email';

const initialState: ICertificaEmailState = {
  esito: null,
  loading: false,
  seed: null,
  email: null,
  username: null,
  error: null,
  msgCode: null,
  otpTtlSeconds: null,
  otpTtlSecondsEmail: null,
  coolDownOTP: null,
  maxTentativi: null,
};

const reducerBase = createReducer(
  initialState,

  on(CERTIFICA_EMAIL, (state) => ({
    ...state,
    loading: true,
    esito: null,      
    error: null,
    msgCode: null,
  })),

  on(CERTIFICA_EMAIL_SUCCESS, (state, { esito, seed, email, msgCode, otpTtlSeconds, otpTtlSecondsEmail, coolDownOTP, maxTentativi }) => ({
    ...state,
    esito,
    seed,
    email,
    msgCode: msgCode ?? null,
    loading: false,
    error: null,
    otpTtlSeconds: otpTtlSeconds ?? state.otpTtlSeconds,
    otpTtlSecondsEmail:otpTtlSecondsEmail ?? state.otpTtlSecondsEmail,
    coolDownOTP: coolDownOTP ?? state.coolDownOTP,
    maxTentativi: maxTentativi ?? state.maxTentativi
  })),

  on(CERTIFICA_EMAIL_FAIL, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(CERTIFICA_OTP, (state) => ({
    ...state,
    loading: true,
    esito: null,
    error: null,
    msgCode: null,
  })),

  on(CERTIFICA_OTP_SUCCESS, (state, { esito, msgCode, username }) => ({
    ...state,
    esito,
    msgCode: msgCode ?? null,
    username,
    loading: false,
    error: null
  })),
  
  on(CERTIFICA_OTP_FAIL, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  
  on(CERTIFICA_EMAIL_PRELOAD, (state, { email }) => ({
    ...state,
    email
  })),
  
  on(CERTIFICA_EMAIL_RESET, () => initialState)
);

export function certificaEmailReducer(
  state: ICertificaEmailState | undefined,
  action: Action
): ICertificaEmailState {
  return reducerBase(state, action);
}
